import { render, staticRenderFns } from "./DeleteContentLabelModal.vue?vue&type=template&id=337321da&scoped=true&"
import script from "./DeleteContentLabelModal.vue?vue&type=script&lang=js&"
export * from "./DeleteContentLabelModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteContentLabelModal.vue?vue&type=style&index=0&id=337321da&prod&lang=scss&"
import style1 from "./DeleteContentLabelModal.vue?vue&type=style&index=1&id=337321da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337321da",
  null
  
)

export default component.exports